import { render, staticRenderFns } from "./CoTwoFuelForm.vue?vue&type=template&id=f7d355ea&scoped=true&"
import script from "./CoTwoFuelForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoFuelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d355ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7d355ea')) {
      api.createRecord('f7d355ea', component.options)
    } else {
      api.reload('f7d355ea', component.options)
    }
    module.hot.accept("./CoTwoFuelForm.vue?vue&type=template&id=f7d355ea&scoped=true&", function () {
      api.rerender('f7d355ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoFuelForm.vue"
export default component.exports